var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-radio"},_vm._l((_vm.data),function(i){return _c('div',{class:{
      radio: true,
      focus: (i[_vm.field.key] === _vm.currentValue)
    },on:{"click":function($event){return _vm.change(i)}}},[_c('span',[_vm._v(_vm._s(i[_vm.field.label]))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }